import type { ChatThread, ThreadId } from "./thread";

/**
 * Placeholder shown while ai-engine generates a thread's title. Shared so the
 * sessions rail, the command-palette history, and the chat breadcrumb all say
 * the same thing — a clinician seeing three different words for one state
 * reads it as three different states.
 */
export const TITLE_PENDING = "Generating title";

/**
 * The display title for a thread, or `null` when there is nothing to show yet.
 *
 * `null` covers every not-yet-named case — title still generating, threads not
 * loaded, id absent from the list — because they all render identically: the
 * `TITLE_PENDING` shimmer. Callers never fall back to the thread id; an opaque
 * number is worse than an honest "still working on it".
 */
export function resolveChatThreadTitle(threads: ChatThread[] | undefined, threadId: ThreadId | null): string | null {
  if (threadId === null || !threads) return null;
  const title = threads.find((t) => t.id === threadId)?.title?.trim();
  return title ? title : null;
}
